// extracted by css-extract-rspack-plugin
export default {"buttonGroup":"CopilotAgentModeButton-module__buttonGroup__XV9lsw2"};